import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  notification: {
    position: 'absolute',
    height: theme.marginBase,
    width: theme.marginBase,
    top: -theme.marginBase / 2,
    right: -theme.marginBase / 2,
    borderRadius: theme.borderRadius.std,
    background: theme.colors.red,
  },
}));

interface Props {
  className?: string;
}

export const NotificationPin = ({ className }: Props) => {
  const classes = useStyles();
  return <div className={classnames(classes.notification, className)} />;
};
